import { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, currency } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) {
      api.get("/orders/me").then((r) => setOrders(r.data)).catch(() => {});
    }
  }, [user]);

  if (loading) {
    return <div className="max-w-3xl mx-auto py-24 text-center text-[#8a8d86]">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: "/account" }} replace />;

  return (
    <div data-testid="account-page" className="max-w-5xl mx-auto px-6 py-16">
      <div className="flex items-start justify-between mb-12">
        <div>
          <p className="overline">My Account</p>
          <h1 className="mt-2 font-serif text-4xl text-[#1e392a] tracking-tight">
            Hello, {user.name?.split(" ")[0] || "friend"}.
          </h1>
          <p className="mt-2 text-sm text-[#8a8d86]">{user.email}</p>
        </div>
        <Button
          data-testid="account-logout-btn"
          variant="ghost"
          onClick={logout}
          className="rounded-full hover:bg-[#efeadd]"
        >
          Sign out
        </Button>
      </div>

      <section>
        <h2 className="font-serif text-2xl text-[#1e392a] mb-6">Your orders</h2>
        {orders.length === 0 ? (
          <div className="border border-dashed border-[#e6e2d8] rounded-md p-10 text-center">
            <p className="text-sm text-[#8a8d86]">You haven't placed any orders yet.</p>
            <Link to="/shop">
              <Button className="mt-4 rounded-full bg-[#1e392a] hover:bg-[#14251b] text-white h-11 px-6">
                Explore the shop
              </Button>
            </Link>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => (
              <div
                key={o.id}
                data-testid={`order-row-${o.order_number}`}
                className="bg-white border border-[#e6e2d8] rounded-md p-6 flex flex-col md:flex-row md:items-center gap-4 justify-between"
              >
                <div>
                  <p className="font-serif text-xl text-[#1e392a]">{o.order_number}</p>
                  <p className="text-xs text-[#8a8d86] mt-1">
                    {new Date(o.created_at).toLocaleDateString()} · {o.items.length} item(s)
                  </p>
                </div>
                <div className="flex items-center gap-6">
                  <span className="text-xs uppercase tracking-widest text-[#c36a4f]">
                    {o.status}
                  </span>
                  <span className="font-serif text-lg text-[#1e392a]">
                    {currency(o.total)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
